import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'searchGames',
    standalone: true,
})
export class SearchGamesPipe implements PipeTransform {
    transform(games: any, searchQuery: any): any {
        if (searchQuery == null) return [];

        return games.filter((game: any) => {
            return game.gameName.toLowerCase().indexOf(searchQuery.toLowerCase()) > -1;
        });
    }
}
